import { render, staticRenderFns } from "./DownloadStatements.vue?vue&type=template&id=14ae5490"
import script from "./DownloadStatements.vue?vue&type=script&lang=js"
export * from "./DownloadStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports